import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import UserStore from 'stores/UserStore';
import AppStore from 'stores/App';

const EditPasswordForm = ({ saveChangesDisable }) => {
  const [form] = Form.useForm();
  const [showResetPassword, setShowResetPassword] = useState(true);

  const compareToFirstPassword = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('The passwords do not match!'));
    },
  });

  const submitResetPassword = async () => {
    try {
      const values = await form.validateFields();
      const MESSAGE = 'Updating Password...';
      AppStore.addLoading(MESSAGE);

      UserStore.changePassword(
        values.currentPassword,
        values.newPassword,
        (success, message) => {
          if (success) {
            AppStore.addSuccess(message);
            setShowResetPassword(false);
          } else {
            if (message === 'invalid old password') {
              AppStore.addError('Your current password is invalid!');
            }
          }
          AppStore.removeLoading(MESSAGE);
        }
      );
    } catch (error) {
      console.error('Validation Failed:', error);
    }
  };

  return (
    <Form
      form={form}
      onFinish={submitResetPassword}
      className="edit-password-form"
    >
      <Form.Item
        label="Current Password"
        name="currentPassword"
        rules={[
          { required: true, message: 'Please input your current password!' },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="Current Password"
        />
      </Form.Item>

      <Form.Item
        label="New Password"
        name="newPassword"
        rules={[
          { required: true, message: 'Please input your new password!' },
          { min: 8, message: 'Password must be at least 8 characters long!' },
        ]}
      >
        <Input.Password prefix={<LockOutlined />} placeholder="New Password" />
      </Form.Item>

      <Form.Item
        label="Confirm New Password"
        name="newPassword2"
        dependencies={['newPassword']}
        rules={[
          { required: true, message: 'Please confirm your new password!' },
          compareToFirstPassword,
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="Confirm New Password"
        />
      </Form.Item>

      <Form.Item>
        <Button disabled={saveChangesDisable} type="primary" htmlType="submit">
          Update Password
        </Button>
      </Form.Item>
    </Form>
  );
};

EditPasswordForm.propTypes = {
  saveChangesDisable: PropTypes.bool,
};

export default EditPasswordForm;
